import * as React from "react";
import {connect} from "react-redux";
import {RootState} from "../../store/reducer/root/RootState";
import {Option} from "ts-option";
import User from "../../model/user/User";
import {Redirect, Route, RouteProps} from "react-router";

interface ReduxProps {
	user: Option<User>
}

type Props = ReduxProps & RouteProps;

/**
 * Route that is restricted for admin roles in the system.
 * Every user that want to enter admin route and doesn't have access will be redirected to main page (the same after login).
 */
class AdminRoute extends Route<Props> {
	render() {
		const Component = this.props.component;
		return this.hasAdminRights() ? <Route exact={this.props.exact} render={props => <Component/>}/> : <Redirect to={"/"}/>;
	}

	/**
	 * Has user admin rights.
	 * @return {boolean} returns true if user is logged in and have admin rights, false otherwise.
	 */
	hasAdminRights(): boolean {
		return this.props.user.map(user => user.data.isAdmin()).getOrElse(false);
	}
}

function mapStateToProps(state: RootState) {
	return {
		user: state.user.user
	}
}

export default connect(mapStateToProps)(AdminRoute)